var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-384 -234)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(384 234)",
    fill: "#ce2d4f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(389.07 247.066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.175,0c.647.006,1.171.4,1.172.882l.03,15.668c0,.481-.522.865-1.169.859s-1.171-.4-1.172-.882L.006.862C0,.381.528,0,1.175,0Z",
    transform: "translate(17.238 -3.073) rotate(45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.171,0c.647-.006,1.171.378,1.17.859l-.03,15.668c0,.481-.526.876-1.173.882s-1.171-.378-1.17-.859L0,.879C0,.4.524,0,1.171,0Z",
    transform: "translate(5.023 -1.41) rotate(-45)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.33feed7b.svg";
export { ForwardRef as ReactComponent };